import axios from "axios";

const apiFactory = () => {
  const instance = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api/v1`,
  });

  instance.interceptors.request.use(async (config) => {
    const newConfig = config;
    try {
      const token = localStorage.getItem("accessToken");
      if (newConfig && newConfig.headers && token) {
        newConfig.headers.Authorization = `Bearer ${token}`;
      } else if (newConfig && newConfig.headers) {
        newConfig.headers.Authorization = "";
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log("Interceptors use error");
    }
    return newConfig;
  });

  return {
    instance,
  };
};

const api = apiFactory();

export default api.instance;
